import { Component } from '@angular/core';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';

@Component({
    selector: 'in-construction',
    templateUrl: './in-construction.component.html',
    styleUrls: ['./in-construction.component.css']
})
export class InConstructionComponent {

	inputFields = [
		{ id: "input_um", focus: true, value: null, action: "this.test1()", valid: false },
	]

	constructor(public beep: MessageBeep) {
		this.beep = beep;
	}

	executeAction(item) {
		eval(item.action);
	}

	test1() {
		this.beep.showAlertCustom("Message", "Input Works!");
	}

	enableGboard() {
		this.beep.showAlertCustom("Message", "Input Works!");
	}
}

